import React, { useEffect } from 'react';
import { RootState } from 'src/store/reducers/state';
import { useDispatch, useSelector } from 'react-redux';
import { defaultDateFormatter } from 'src/components/utilities/utils';
import { useAnalyticsActions } from 'src/store/analytics/actions';
import Pagination from 'src/components/common/pagination';
import { getCourseStatusBadgeColor } from 'src/components/utilities/utils';
interface IProps {
  memberId: string;
}

const CourseVideoAnalytics: React.FC<IProps> = ({ memberId }) => {
  const dispatch = useDispatch();
  const analyticsAction = useAnalyticsActions(dispatch);
  const { coursePaginationMeta, analyticsCourse } = useSelector((state: RootState) => {
    return {
      coursePaginationMeta: state.analytics.coursePaginationMeta,
      analyticsCourse: state.analytics.analyticsCourse
    };
  });
  const handlePageChange = (pageNumber: number | string) => {
    const data = { pageNumber, id: memberId };
    analyticsAction.getCourseAnalyticsRequest(data);
  };

  const handleCourseClick = (courseId: string) => {
    window.open(
      `/analytic/singleCourse/${courseId}`,
      '_blank'
    )
  }

  return (
    <div className="my-6">
      <div className="flex flex-col justify-center h-full">
        <div className="w-full mx-auto bg-white shadow-card rounded-lg relative">
          <div className="px-5 py-4 border-b border-gray-100">
            <h2 className="font-semibold ">Course Results</h2>
          </div>
          <div className="p-3">
            <div className="overflow-x-auto">
              <table className="table-auto w-full">
                <thead className="text-xs font-semibold   bg-gray-50">
                  <tr>
                    <th className="p-2">
                      <div className="font-semibold text-left">COURSE</div>
                    </th>
                    <th className="p-2">
                      <div className="font-semibold text-left">COURSE STATUS</div>
                    </th>
                    <th className="p-2">
                      <div className="font-semibold text-center">COMPLETION DATE</div>
                    </th>
                    <th className="p-2">
                      <div className="font-semibold text-center">PASS RATE</div>
                    </th>
                    <th className="p-2">
                      <div className="font-semibold text-center">SCORE</div>
                    </th>
                    <th className="p-2">
                      <div className="font-semibold text-center">CREDITS</div>
                    </th>
                    <th className="p-2">
                      <div className="font-semibold text-left">CREDITS SENT</div>
                    </th>
                  </tr>
                </thead>
                {analyticsCourse && analyticsCourse.length ? (
                  <tbody className="text-sm divide-y divide-gray-100">
                    {analyticsCourse &&
                      analyticsCourse.map((item, index) => {
                        return (
                          <tr key={index} className='cursor-pointer' onClick={() => handleCourseClick(item.courseId)}>
                            <td className="p-2">
                              <div className="text-left">{item.courseName}</div>
                            </td>
                            <td className="p-2">
                              <div className="text-left">
                                <span
                                  className={`${getCourseStatusBadgeColor(
                                    item.couseStatus
                                  )} text-xs font-medium mr-2 px-2.5 py-0.5 rounded dark:bg-yellow-900 dark:text-yellow-300`}>
                                  {item.couseStatus}
                                </span>
                              </div>
                            </td>
                            <td className="p-2">
                              <div className="text-center">
                                {item.completionDate
                                  ? defaultDateFormatter(item.completionDate)
                                  : ''}
                              </div>
                            </td>
                            <td className="p-2">
                              <div className="text-center">{item.courseCompletionPercentage}%</div>
                            </td>
                            <td className="p-2">
                              <div className="text-center">{item.score}%</div>
                            </td>

                            <td className="p-2">
                              <div className="text-center">{item.creditsAchieved}</div>
                            </td>
                            <td className="p-2">
                              <div className="text-left">
                                {item.creditsSent ? (
                                  <i className="fa fa-check text-danger text-lg text-green-500"></i>
                                ) : (
                                  ''
                                )}
                              </div>
                            </td>
                          </tr>
                        );
                      })}
                  </tbody>
                ) : (
                  <tbody>
                    <tr>
                      <td className="p-2">
                        <div className="text-center">No data Found</div>
                      </td>
                    </tr>
                  </tbody>
                )}
              </table>
              {!!coursePaginationMeta && !!Object.keys(coursePaginationMeta).length && (
                <Pagination
                  currentPage={coursePaginationMeta.pageNumber}
                  totalCount={coursePaginationMeta.totalCount}
                  pageSize={coursePaginationMeta.pageSize}
                  onPageChange={(page: any) => handlePageChange(page)}
                />
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CourseVideoAnalytics;
